/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePointConfiguration } from '../../models/charge-point-configuration';

export interface GetChargePointConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;
}

export function getChargePointConfiguration(http: HttpClient, rootUrl: string, params: GetChargePointConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointConfiguration>> {
  const rb = new RequestBuilder(rootUrl, getChargePointConfiguration.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePointConfiguration>;
    })
  );
}

getChargePointConfiguration.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/getconfiguration';
